import angular from 'angular';
import { routes, routing } from './authentication.routes';
import LoginController from './login/login.controller';
import ProfileController from './profile/profile.controller';
import SettingsController from './settings/settings.controller';
import AuthenticationService from './authentication.service';
import { AuthenticationHandler } from "./authentication.handler";
export default angular.module('app.authentication', [])
    .config(routes)
    .config(routing)
    .controller('LoginController', LoginController)
    .controller('ProfileController', ProfileController)
    .controller('SettingsController', SettingsController)
    .factory('AuthenticationHandler', AuthenticationHandler)
    .service('AuthenticationService', AuthenticationService)
    .directive('valueMatches', ['$parse', function ($parse) {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModel) {
                var originalModel = $parse(attrs.valueMatches), secondModel = $parse(attrs.ngModel);
                // Watch for changes to this input
                scope.$watch(attrs.ngModel, function (newValue) {
                    ngModel.$setValidity(attrs.name, newValue === originalModel(scope));
                });
                // Watch for changes to the value-matches model's value
                scope.$watch(attrs.valueMatches, function (newValue) {
                    ngModel.$setValidity(attrs.name, newValue === secondModel(scope));
                });
            }
        };
    }])
    .name;
